<template>
  <div class="fucking-container">
    <el-row :gutter="20" style="margin-top:20px;">
      <el-col :span="14">
        <detailTitle
          title="门店推荐"
          :check="checkControl.recommandProduct"
          :prop="checkControl.recommandProductProp"
          v-on="$listeners"
        />
        <div style="height: 270px;overflow-y: scroll; background-color: #fff;">
          <el-table :data="keleCommodityCopy" :show-overflow-tooltip="false">
            <el-table-column
              align="center"
              prop="commodity_name"
              label="产品"
            ></el-table-column>
            <el-table-column align="center" label="数量">
              <template slot-scope="{row}">
                <el-input-number
                  v-model="row.number"
                  style="width:85px !important; transform: scale(.9)"
                  :min="1"
                  size="mini"
                  :step="1"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="price"
              width="104"
              label="单价"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="now_price"
              label="现价"
              width="100"
            >
              <template slot-scope="{row}">
                <el-input-number
                  v-model="row.now_price"
                  class="recommendNumberInput"
                  :min="0"
                  :value="row.now_price"
                  :controls="false"
                  size="mini"
                />
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="all_price"
              label="总价"
            ></el-table-column>
            <el-table-column align="center" width="56" label="操作">
              <template slot-scope="scope">
                <div
                  style="color:red;cursor:pointer"
                  @click="del(scope.row.id)"
                >
                  <i class="el-icon-delete"></i>
                  <!-- 删除 -->
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="white-block">总计：{{ totalPrice }}元</div>
      </el-col>
      <el-col class="product-list" :span="10">
        <detailTitle
          title="门店产品"
          :check="checkControl.productList"
          :prop="checkControl.productListProp"
          v-on="$listeners"
        />
        <el-checkbox-group v-model="selectedIds" @change="groupCheckedChange">
          <el-checkbox
            v-for="item in keleMoreCopy"
            :key="item.id"
            :label="item.id"
            ><template>
              {{ item.commodity_name
              }}<span style="position: absolute; right: 80px;">{{
                item.price
              }}</span>
            </template></el-checkbox
          >
        </el-checkbox-group>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="btn-box">
      <el-col :span="14">
        <div>
          <el-form inline>
            <el-form-item style="margin-bottom:0" label="请选择技师">
              <el-select v-model="masseur_id">
                <el-option
                  v-for="item in doctors"
                  :key="item.id"
                  :label="item.truename"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col :span="10">
        <div class="btn" @click="save">发送</div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import detailTitle from './detailTitle';
import toast from '@/toast';
import {deepClone} from '../../../util';

export default {
  components: {
    detailTitle
  },
  props: {
    doctors: [Array],
    recommendProductId: [Array],
    keleProduct: {
      type: [Object, Array],
      default() {
        return {
          keleMore: [],
          keleCommodity: []
        };
      }
    },
    id: {},
    record_id: {},
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checkControl: {
        recommandProduct: false,
        recommandProductProp: 'recommandProduct',
        productList: false,
        productListProp: 'productList'
      },
      masseur_id: '',
      options: [],
      selectedIds: [],
      keleMoreCopy: [],
      keleCommodityCopy: []
    };
  },
  computed: {
    totalPrice() {
      this.keleCommodityCopy.forEach(it => {
        if (+it.now_price < 0) {
          it.now_price = '0.00'
        }
        it.all_price = +it.now_price * +it.number
      })
      if (this.keleCommodityCopy.length === 0) {
        return 0
      }
      return this.keleCommodityCopy.map(it => +it.all_price).reduce((a, b) => a + b)
    },
  },
  watch: {
    keleProduct: {
      immediate: true,
      handler(data) {
        if (!data.keleMore || !data.keleMore.length) return;
        if (data.keleCommodity && data.keleCommodity.length) {
          data.keleCommodity.forEach(item => {
            const {id} = item;
            if (data.keleMore.find(_item => _item.id === id)) return;
            data.keleMore.unshift(item);
          });
        }
        const keleMore = deepClone(data.keleMore);
        const keleCommodity = deepClone(data.keleCommodity);
        this.keleMoreCopy = keleMore;
        this.selectedIds = keleMore
          .map(item => item.id)
          .filter(id => keleCommodity.find(item => item.id === id));

        this.keleCommodityCopy = keleCommodity.map(item => ({
          ...item,
          isUnique: !keleMore.some(_item => _item.id === item.id)
        }));
      }
    }
  },
  methods: {
    uniqueArr(arr) {
      return Array.from(new Set(arr));
    },

    groupCheckedChange(val) {
      const list = this.keleMoreCopy.filter(item => val.includes(item.id));
      this.keleCommodityCopy = this.keleCommodityCopy.filter(
        item => item.isUnique || list.some(_item => _item.id === item.id)
      );
      list.forEach(item => {
        if (!this.keleCommodityCopy.some(_item => _item.id === item.id)) {
          this.keleCommodityCopy.push(item);
        }
      });
    },
    del(id) {
      this.keleCommodityCopy = this.keleCommodityCopy.filter(
        item => item.id !== id
      );
      this.selectedIds = this.selectedIds.filter(item => item !== id);
    },
    saveDetail() {
      const params = {
        u_id: this.id,
        record_id: this.record_id,
        masseur_id: this.masseur_id,
        hand_type: 1,
        goods_arr: this.keleCommodityCopy
          .filter(it => !!it.all_price)
          .map(it => ({
            price: it.now_price * it.number ,
            number: it.number,
            id: it.id
          }))
      };
      this.$http
        .post(this.$url.saveDetail, params)
        .then(res => {
          this.$emit('next');
          toast('操作成功');
        })
        .catch(this.$catch);
    },
    save() {
      if (this.type) {
        this.$http
          .post(this.$url.testSum, {
            u_id: this.id,
            masseur_id: this.masseur_id,
            goods_arr: this.keleCommodityCopy
              .filter(it => !!it.all_price)
              .map(it => ({
                price: it.now_price * it.number,
                number: it.number,
                id: it.id
              }))
          })
          .then(res => {
            this.$emit('next');
            toast('操作成功');
          })
          .catch(this.$catch);
        return;
      }
      this.saveDetail();
    },
    handleRowChange(row, data) {
      console.log(row.number, data);
      Object.assign(row, data);
      this.$emit('update:product', [...this.keleMoreCopy]);
    }
  }
};
</script>
<style lang="scss">
.recommendNumberInput {
  width: 90px;
  padding-left: 0;
  padding-right: 0;

  .el-input__inner {
    font-size: 16px;
  }
}
.el-checkbox__label {
  font-size: 16px !important;
}
</style>

<style lang="scss">
.product-list {
  .el-checkbox-group {
    padding: 10px 20px;
    background-color: #fff;
    height: 300px;
    overflow-y: scroll;
    overflow-x: hidden;
    .el-checkbox {
      height: 30px;
      display: flex;
      align-items: center;
      position: relative;
      color: #333;
      margin-right: 0;
      font-size: 16px;
      margin-bottom: 10px;
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #409eff;
        font-size: 16px;
      }
      .el-checkbox__label {
        font-size: 16px;
      }
    }
  }
}
.white-block {
  background-color: #fff;
  font-size: 16px;
  text-align: right;
  height: 50px;
  line-height: 50px;
  box-sizing: border-box;
  padding-right: 20px;
}
.fucking-container {
  .el-table {
    font-size: 16px;
  }
  .el-form {
    .el-form-item__label,
    .el-form-item__content {
      font-size: 16px;
    }
  }
  .btn-box {
    margin-top: 20px;
    display: flex;
    align-items: center;
    height: 80px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 20px;
    .btn {
      width: 180px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      color: #fff;
      font-size: 16px;
      border-radius: 20px;
      background-color: #409eff;
      cursor: pointer;
    }
  }
}
</style>
